
import styled from 'styled-components';

import {
  FlexCol,
} from 'common/styles/oc-styled-components';

import { BREAKPOINTS, colors } from 'common/styles/style-constants';
import { Icon, Input } from 'opencare-crown';

interface StyledInputProps {
  fontSize?: string;
  capitalize?: string;
  height?: string;
  margin?: string;
  padding?: string;
  textalign?: string;
  width?: string;
}
export const StyledInput = styled(Input)<StyledInputProps>`
  && {
    font-size: ${(props) => props.fontSize};
    text-transform: ${(props) => props.capitalize === 'true' && 'capitalize'};
    height: ${(props) => props.height || '60px'};
    margin: ${(props) => props.margin || 0};
    padding: ${(props) => props.padding};
    text-align: ${(props) => props.textalign};
    width: ${(props) => props.width};
    max-width: 100%;
    border-radius: 10px;
    box-shadow: inset 0px 2px 3px rgba(0, 0, 0, 0.1);
    border: 1px solid
      ${(props) => (props.error === 'true' ? 'red' : colors.gray6)};

    &::placeholder {
      color: ${colors.gray8};
    }

    &:not(:disabled) {
      &:active,
      &:focus {
        border-color: ${colors.blue};
        box-shadow: 0 0 3px ${colors.blue};
        outline: none !important;
      }

      &:hover {
        border-color: ${colors.blue};
        box-shadow: inset 0px 2px 3px rgba(0, 0, 0, 0.05);
      }
    }
  }
`;

export const ResponsiveInputRow = styled(FlexCol)`
  && {
    @media (min-width: ${BREAKPOINTS.tabletMin}px) {
      flex-direction: row;
    }
  }
`;

export const StyledLock = styled(Icon)`
  && {
    bottom: ${(props) => props.bottom};
    color: ${colors.ash};
    font-size: ${(props) => props.size || '12px'};
    height: 12px;
    margin: ${(props) => props.margin};
    position: relative;
    width: 18px;
  }
`;

export const Link = styled.a`
  border-bottom: 1px solid ${colors.blue};
  color: ${colors.blue};
  transition: border 0.1s;

  &:hover,
  &:focus {
    color: ${colors.blue};
    border-color: transparent;
  }
`;

